export default __webpack_public_path__ + "static/media/pby_aws_logo.ad649bb1.png";